<template>
  <el-container class="index-con">
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>
    <div class="index-page"></div>
    <div style="background-color: #F7F9FB; padding-top: 35px;">
      <div class="main-con">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">海量数据</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: path==1?'/index/classroom':'/index/live' }">{{path==1?'课程':'直播'}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{path==1?'课程详情':'直播详情'}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 卡片 -->
        <div class="authentication">
          <div style="display: flex;align-items: center;">
            <img class="product-image" :src="info.courseImg">
            <div class="product-card">
              <p class="product-card-name">{{info.courseName}}</p>
              <div class="product-card-kv">
                <p class="key">课程讲师：<span v-for="item,index in lectures" style="margin-right: 10px;">{{item.name}}</span></p>
                <p class="key">课程学时：<span>{{info.durationHour}}小时</span></p>
                <p class="key">适合群体：<span>{{info.suitGroup}}</span></p>
                <p class="key" v-if="info.courseForm==2">授课地址：<span>{{info.teachAddress}}</span></p>
                <!-- <p class="key" v-if="status!=3">授课形式：<span>{{info.courseForm==1?'线上':'线下'}}</span></p> -->
                <!-- <p class="product-card-enroll-moeny" style="margin-top: 10px" v-else ><span>￥</span>{{info.coursePrice}}</p> -->
              </div>
              <div class="product-card-coupon" v-if="type==1">
                <div class="product-card-coupon-item" :class="item.hasFlag==1?'popup-coupon-cur':''" v-for="item,index in couponsList" :key="index" v-if="index<2">
                  <p class="product-card-coupon-item-discount">{{item.discountRatio *10}}<span>折</span></p>
                  <div class="product-card-coupon-item-content">
                    <p class="product-card-coupon-item-content-name">{{item.couponName}}</p>
                    <p class="product-card-coupon-item-content-time">{{item.createTime.split(' ')[0]}}</p>
                  </div>
                  <div class="product-card-coupon-item-receive" v-if="item.hasFlag==0" @click="getCoupon(item.id)">领</div>
                  <div class="product-card-coupon-item-receive" v-else>已<br>领</div>
                </div>
                <div class="product-card-coupon-more" v-if="couponsList.length>2" @click="dialogFormVisible4 = true">更多 ></div>
              </div>
              <div class="product-card-enroll">
                <p class="product-card-enroll-moeny"><span>￥</span>{{info.coursePrice}}</p>

                <div v-if="info.type == 1">
                  <div v-if="info.ifSign==1 && info.plans.length<=0">
                    <el-button size="small" type="warning" style="padding: 12px 80px;width: auto;background-color: #ff821c">已购买</el-button>
                    <!-- <el-button class="buttons" size="small" style="padding: 12px 26px;" v-if="info.plans.length>0">{{info.learnCount}}人想学</el-button> -->
                  </div>
                  <div v-else>
                    <el-button size="small" type="warning" @click="auditStatus" style="padding: 12px 80px;width: auto;background-color: #ff821c"  v-if="info.plans.length<=0">立即报名</el-button>
                    <el-button class="buttons" size="small" style="padding: 12px 26px;"  v-else>{{info.learnCount}}人想学</el-button>
                  </div>
                </div>
                <div v-else>
                  <div v-if="info.ifSign==0">
                    <el-button class="buttons" size="small" style="padding: 12px 26px;">{{info.learnCount}}人想学</el-button>
                  </div>
                </div>

              
                <div style="display: flex;align-items: center;justify-content: flex-end;flex: 1;">
                  <div class="product-card-enroll-share" @click="onCollect">
                    <img src="../../assets/img/icon36.png" v-if="info.ifCollection==0">
                    <img src="../../assets/img/icon37.png" v-else>
                    <p :style="{color:info.ifCollection==1?'#f25801':''}">收藏</p>
                  </div>
                
                  <div class="product-card-enroll-share" style="margin-left: 20px;" @click="dialogFormVisible5 = true">
                    <img src="../../assets/img/icon18.png">
                    <p>分享</p>
                  </div>
                </div>
                
              </div>
            </div>
          </div>

          <div class="plan" v-if="info.plans.length>0">
            <div class="head" style="align-items: center;">
              <div class="head-left"> 
                <p class="title">开课计划</p>
                <p class="tiao"></p>
              </div>
              <!-- <div>
                <i class="el-icon-arrow-left" style="color: #B8B8B8;"></i>
                <i class="el-icon-arrow-right" style="color: #B8B8B8;"></i>
              </div> -->
            </div>
            <ul class="plan-ul">
              <li class="plan-ul-li" v-for="item,index in info.plans" :key="index" :style="{border:planIndex==index?'1px solid #F25902':''}" 
                @click="getPlanInfo(item.id,index)"
                
                >
                <div class="plan-ul-li-qi">
                  <p class="plan-ul-li-qi-p1">{{ item.title }}</p>
                  <!-- <p class="plan-ul-li-qi-p2">{{item.typeName}}</p> -->
                  <!-- {{item.type==1?'线上':'线下'}} |  -->
                </div>
                <div class="plan-ul-li-date">
                  <p>
                    <img src="../../assets/img/icon20.png">
                    <span>{{ item.planTime.split(' ')[0] }} - {{ item.endTime.split(' ')[0] }}</span>
                  </p>
                  <!-- v-if="isPlanTimeValid(item.planTime)" -->
                  <div style="display: flex;align-items: center;" >
                    <!-- <p style="margin-right: 10px;font-size: 14px;color: #FF6A00; cursor: pointer;" >计划详情</p> -->
                    <el-button size="mini" type="info" round style="padding: 5px 15px;width: auto;" disabled v-if="isPlanTimeValid(item.signEndTime) && item.ifSign!=1">立即报名</el-button>
                    <el-button size="mini" type="warning" round style="padding: 5px 15px;width: auto;background-color: #ff821c" @click.stop="courseStatus(item.courseId,item.id)" v-else-if="item.ifSign!=1">立即报名</el-button>
                    <el-button size="small" type="warning" round style="padding: 5px 15px;width: auto;background-color: #ff821c" v-else>已购买</el-button>
                  </div>
                  <!-- <div style="display: flex;align-items: center;" v-else>
                    <el-button size="small" type="warning" round style="padding: 5px 15px;width: auto;background-color: #ff821c">报名尚未开始</el-button>
                  </div> -->
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: #F7F9FB; padding-top: 40px">
      <div class="main-con" >
        <div class="exam-contetn">
          <div style="width: 70%;">
            <div class="exam-contetn-text">
              <!-- 计划详情 -->
              <div class="course" v-if="planDetail && groupList.length<=0">
                <div class="head">
                  <div class="head-left"> 
                    <p class="title">计划详情</p>
                    <p class="tiao"></p>
                  </div>
                </div>
                <div class="marker" v-html="planDetail"></div>
              </div>

              <!-- 课程教材 -->
              <!-- v-if="info.ifSign==1 && info.courseMaterial" -->
              <div class="course" v-if="info.ifSign==1 && info.courseMaterial">
                <div class="head">
                  <div class="head-left"> 
                    <p class="title">课程教材</p>
                    <p class="tiao"></p>
                  </div>
                </div>
                <div class="textbook" v-for="item,index in info.courseMaterial" :key="index">
                  <p>
                    <img src="@/assets/img/icon22.png">
                    <span>{{item.name}}</span>
                  </p>
                  <p style="cursor: pointer;" @click="downloadFile(item.url)">
                    <img src="@/assets/img/icon23.png">
                    <span style="color: #FF6A00;font-size: 12px;line-height: 12px;">下载</span>
                  </p>
                </div>
              </div>

              <!-- 课程介绍 -->
              <div class="course" >
                <div class="head">
                  <div class="head-left"> 
                    <p class="title">课程介绍</p>
                    <p class="tiao"></p>
                  </div>
                </div>
                <div class="marker" v-html="info.courseDesc"></div>
              </div>

              <!-- 课程目录 -->
              <div class="course" v-if="groupList && groupList.length>0">
                <div class="head">
                  <div class="head-left"> 
                    <p class="title">课程目录</p>
                    <p class="tiao"></p>
                  </div>
                </div>
                <div class="problem">
                  <el-collapse accordion>
                    <el-collapse-item v-for="item,index in groupList" :key="index">
                      <template slot="title">
                        <p class="titles">第{{index+1}}章 ： {{item.groupName}}</p>
                      </template>
                      <div class="text" :style="{padding:status==3?'16px 0':''}" v-for="items,indexs in item.children" :key="indexs" @click="playback(items.id,info.learnDuration,items.pullUrl,items.liveStatus)">
                        <div class="text-name">
                          <img src="../../assets/img/icon24.png">
                          <span>{{items.itemName}}</span>
                        </div>
                        <div class="text-time" v-if="info.type == 2">
                          <span v-if="items.videoId">{{items.durationTotal | formatSeconds }}</span>
                          <p v-if="items.videoId">回放</p>
                          <p v-else>观看</p>
                        </div>
                        <div class="text-time" v-else>
                          <span>{{items.durationTotal | formatSeconds }}</span>
                          <p v-if="info.ifSign==1 && info.type==3" >回放</p>
                          <p v-if="info.ifSign==0">试看</p>
                          <div v-if="info.ifSign==1" class="text-time-record">最近学习{{(items.learnProcess *100).toFixed(2)}}%</div>
                        </div>
                        
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>

            </div>
          </div>
          
          <div class="exam-contetn-item">
            <!-- 学习进度 -->
            <div class="instructor" v-if="info.ifSign==1 && info.courseMember">
              <p class="instructor-title">学习进度</p>
              <div class="progress">
                <p>整体进度: {{learnProcess.toFixed()}}%</p>
                <el-progress :percentage="learnProcess.toFixed()" color="#FF821E"></el-progress>
                <p>已学时长: {{info.courseMember.learnDuration | formatSeconds}}秒</p>
              </div>
            </div>

            <!-- 课堂讲师 -->
            <div class="instructor" v-if="lectures.length>0">
              <p class="instructor-title">讲师介绍</p>
              <ul>
                <li v-for="item,index in lectures" :key="index" v-if="index<3">
                  <el-image 
                    class="instructor-avatar"
                    :src="item.avatar" 
                    :preview-src-list="[item.avatar]">
                  </el-image>
                  <div class="instructor-item">
                    <p class="instructor-item-name">{{item.name}}</p>
                    <p class="instructor-item-speciality" v-html="item.personDesc"></p>
                  </div>
                </li>
                <li v-for="item,index in lectures" :key="index" v-if="index>2 && isInstructor">
                  <el-image 
                    class="instructor-avatar"
                    :src="item.avatar" 
                    :preview-src-list="[item.avatar]">
                  </el-image>
                  <div class="instructor-item">
                    <p class="instructor-item-name">{{item.name}}</p>
                    <p class="instructor-item-speciality" v-html="item.personDesc"></p>
                  </div>
                </li>
              </ul>
              <div style="text-align: center;padding-top: 12px; border-top: 1px solid #EFEFEF;cursor: pointer;" v-if="lectures.length>3">
                <i class="el-icon-arrow-up" @click="onInstructor" v-if="isInstructor"></i>
                <i class="el-icon-arrow-down" @click="onInstructor" v-else></i>
              </div>
            </div>

            <!-- 关联考试 -->
            <div class="correlation" v-if="info.exams.length>0">
              <p class="correlation-title">关联考试</p>
              <ul>
                <li v-for="item,index in info.exams" :key="index" @click="onExamDetails(item.id)">
                  <img class="correlation-item-img" :src="item.examImg">
                  <p class="correlation-item-name">{{item.examName}}</p>
                  <p class="correlation-item-time">
                    <img class="correlation-item-time-img" src="../../assets/img/icon20.png">
                    <span>{{item.signStartTime.split(' ')[0]}} - {{ item.signEndTime.split(' ')[0] }}</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="popup">
      <!-- 报名 -->
      <el-dialog title="" :visible.sync="dialogFormVisible1">
        <p class="popup-title">填写报名表</p>
        <div class="popup-form">
          <el-form :label-position="labelPosition" label-width="80px" :model="userInfo" class="demo-ruleForm">
            <el-form-item label="姓名：">
              <el-input v-model="userInfo.realName" placeholder="请输入真实姓名" disabled></el-input>
            </el-form-item>
            <el-form-item label="证件号：">
              <el-input v-model="userInfo.idCard" placeholder="请输入证件号" disabled></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
              <el-input v-model="userInfo.mobile" placeholder="请输入手机号" disabled></el-input>
            </el-form-item>
            <div class="checked">
              <el-checkbox size="mini" text-color="#ff821c" fill="#ff821c" v-model="checked">我已阅读</el-checkbox>
              <span class="checkbox-span" @click="commonText('rcfzzxbmgz')">《海量数据学院报名规则》，保证报名信息真实有效</span>
            </div>
            <el-form-item style="text-align: center;">
              <el-button style="background-color: #ff821c" size="small" type="warning" @click="signUp">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

      <!-- 订单支付 -->
      <el-dialog title="" :visible.sync="dialogFormVisible2">
        <p class="popup-title">订单支付</p>
        <div class="popup-form" style="padding:40px">
          <!-- 课程信息 -->
          <div class="popup-table">
            <div class="popup-table-column" style="width: 46%;">
              <p class="popup-table-column-key">课程信息</p>
              <p class="popup-table-column-val">{{info.courseName}}</p>
            </div>
            <div class="popup-table-column" style="width: 34%;">
              <p class="popup-table-column-key">授课形式</p>
              <p class="popup-table-column-val">{{info.courseForm==1?'线上':'线下'}}</p>
            </div>
            <div class="popup-table-column" style="width: 20%;">
              <p class="popup-table-column-key">总价</p>
              <p class="popup-table-column-val" style="color: #F25902;">¥ {{info.coursePrice}}</p>
            </div>
          </div>

          <div class="popup-form-coupon" v-if="info.couponsList.length>0">
            <el-collapse  v-model="activeNames" accordion>
              <el-collapse-item title="请选择优惠券" :name="info.couponsList.length>0?'coupons':''" style="color: #a9a9a9;">
                <div class="product-card-coupon" style="display: block;">
                  <div class="product-card-coupon-item" v-if="item.hasFlag==1" v-for="item,index in info.couponsList" :key="index" @click="onCoupon(item.id,item.discountRatio)">
                    <p class="product-card-coupon-item-discount">{{ item.discountRatio *10 }}<span>折</span></p>
                    <div class="product-card-coupon-item-content">
                      <p class="product-card-coupon-item-content-name">{{item.couponName}}</p>
                      <p class="product-card-coupon-item-content-time">{{ item.createTime }}</p>
                    </div>
                    <div class="product-card-coupon-item-receive">
                      <img src="../../assets/img/icon3.png" v-if="item.checked">
                      <img src="../../assets/img/icon2.png" v-else>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>

          <!-- 支付方式 -->
          <div class="popup-way">
            <p class="popup-way-title">支付方式</p>
            <ul>
              <li class="popup-way-item" v-for="item,index in wayItem" :key="index" @click="onChecked(index)">
                <div style="height:12px;">
                  <img v-if="payCur==index" class="popup-way-item-checked" src="../../assets/img/icon25.png">
                  <img v-else class="popup-way-item-checked" src="../../assets/img/icon26.png">
                </div>
                <img class="popup-way-item-wx" v-if="index==0" src="../../assets/img/wx.png">
                <img class="popup-way-item-wx" v-else-if="index==1" src="../../assets/img/zfb.png">
                <img class="popup-way-item-wx" v-else src="../../assets/img/yl.png">
                <span class="popup-way-item-name">{{item.name}}</span>
              </li>
            </ul>
            <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 40px">
              <el-button style="background-color: #ff821c" size="medium" type="warning" @click="onNextStep">下一步</el-button>
              <el-button class="buttons" size="medium" @click="dialogFormVisible2 = false">取消</el-button>
            </div>
          </div>

          <!-- 支付金额 -->
          <!-- <div class="popup-pay">
            <div class="popup-pay-type" v-if="payCur!=2">
              <div class="popup-pay-item">
                <img class="popup-pay-item-code" src="../../assets/img/avatar.png">
                <div class="popup-pay-item-val">
                  <img src="../../assets/img/icon27.png" v-if="payCur==0">
                  <img src="../../assets/img/zfb.png" v-else>
                  <p>{{payCur==0?'微信支付':'支付宝支付'}}</p>
                </div>
              </div>
              <div class="popup-pay-moeny">
                <p class="popup-pay-moeny-key">应付金额：</p>
                <p class="popup-form-moeny"><span>￥</span>{{info.coursePrice}}</p>
                <p class="popup-pay-moeny-tips">支付即视为您同意<span>《海量数据学院用户服务协议》《海量数据学院用户隐私政策》</span></p>
              </div>
            </div>
            <div class="popup-pay-transfer" v-else>
              <ul>  
                <li>
                  <p class="key">转账金额：</p>
                  <p style="margin-bottom:0;" class="popup-form-moeny" ><span>￥</span>{{info.coursePrice}}</p>
                </li>
                <li>
                  <p class="key">收款公司名称：</p>
                  <p class="val">北京海量数据技术股份有限公司</p>
                </li>
                <li>
                  <p class="key">收款账户：</p>
                  <p class="val"> 5969009027106031996694265</p>
                </li>
                <li>
                  <p class="key">开户行名称：</p>
                  <p class="val">招商银行xxx支行</p>
                </li>
              </ul>
              <p class="popup-pay-zhu">注：请在转账支付成功后到我的订单—凭证上传入口上传缴费证明</p>
            </div>
          </div> -->
        </div>
      </el-dialog>

      <!-- 报名不成功 -->
      <el-dialog title="" :visible.sync="dialogFormVisible3">
        <p class="popup-title">温馨提示</p>
        <div class="popup-form" style="padding-bottom: 70px;">
          <p class="popup-form-title" style="border-bottom: none;padding-bottom: 4px;"><span>*</span>请先完成以下考试才可报名</p>
          <div class="popup-form-tips">
            <p class="popup-form-tips-text">海量数据培训海量数据培训海量数据培训</p>
            <p class="popup-form-tips-g"></p>
            <p class="popup-form-tips-type">未通过</p>
            <p class="popup-form-tips-g"></p>
            <p class="popup-form-tips-sub">点击前往 ></p>
          </div>
          <div style="text-align: center;">
            <el-button size="medium" type="warning" style="width: 40%;background-color: #ff821c" @click="dialogFormVisible3 = false">我知道了</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 更多优惠券 -->
      <el-dialog title="" :visible.sync="dialogFormVisible4">
        <p class="popup-title">更多优惠券</p>
        <div class="popup-form" style="padding:60px 110px 30px;">
          <div class="product-card-coupon popup-coupon">
            <div class="product-card-coupon-item popup-coupon-item" :class="item.hasFlag==0?'':'popup-coupon-cur'" v-for="item,index in couponsList" :key="index" v-if="item.isShow == 1">
              <p class="product-card-coupon-item-discount">{{ item.discountRatio * 10}}<span>折</span></p>
              <div class="product-card-coupon-item-content">
                <p class="product-card-coupon-item-content-name">{{item.couponName}}</p>
                <p class="product-card-coupon-item-content-time">{{item.createTime}}</p>
              </div>
              <div class="product-card-coupon-item-receive" v-if="item.hasFlag==0" @click="getCoupon(item.id)">领</div>
              <div class="product-card-coupon-item-receive" v-else>已<br>领</div>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 分享 -->
      <el-dialog title="" :visible.sync="dialogFormVisible5">
        <p class="popup-title">分享</p>
        <div class="popup-form" style="padding:60px 180px 80px;text-align: center">
          <qrcode :text="'https://education.vastdata.com.cn/mobile/#/pages/course/details?id='+id+'&type=1'"></qrcode>
          <p class="popup-share-text">微信扫描二维码查看</p>
          <div class="popup-share-copy" @click="copyText">
            <p>复制链接</p>
            <img src="../../assets/img/icon33.png">
          </div>
        </div>
      </el-dialog>

      <el-dialog title="" :visible.sync="dialogFormVisible6">
        <p class="popup-title">微信支付</p>
        <div class="popup-form" style="padding:60px 180px 80px;text-align: center">
          <img class="popup-share-img" :src="examHtml">
          <p class="popup-share-text">微信扫描二维码支付</p>
          <el-button style="background-color: #ff821c" size="medium" type="warning" @click="getOrderInfo">我已支付</el-button>
        </div>
      </el-dialog>
    </div>
    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
import qrcode from '../../components/qrcode.vue'
import { userInfo,courseInfo,courseSign,coursePay,collectCourse,getCoupon,orderInfo,editExamOrder,planInfo } from '../../api/userMG'
import axios from 'axios';
export default {
  name: 'index',
  data() {
    return {
      id:'',
      discount:'',
      status:1,
      info:{},
      content:'',
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4:false,
      dialogFormVisible5: false,
      dialogFormVisible6: false,
      labelPosition: 'top',
      userInfo:{},
   
      value: [],
  
      checked:false,
     
      isInstructor:false,
      loading:false,

      wayItem:[
        {
          name:'微信支付'
        },
        {
          name:'支付宝支付'
        },
        // {
        //   name:'企业银行转帐'
        // }
      ],
      payCur:0,
      payInfo:{},
      orderId:'',
      examHtml:'',
      learnProcess:0,
      couponChecked:false,
      couponId:'',
      discountRatio:-1,
      path:1,
      groupList:[],
      lectures:[],
      planIndex:0,
      planId:'',
      planDetail:'',
      type:1,
      couponsList:[],
      activeNames:['coupons']
    }
  },
  // 注册组件
  components: {
    navcon,
    footers,
    qrcode
  },

  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.discount = this.$route.query.discountId;
    this.path = this.$route.query.path;
    this.getCourseInfo();
  },
  methods:{
    isPlanTimeValid(planTime) {
      const now = new Date();
      const planDate = new Date(planTime);
      return planDate < now;
    },
    onExamDetails(id){
      this.$router.push({path:'/index/examDetails', query: { id: id, type:1 }})
    },
    commonText(code){
      this.$router.push({path:'/login/text',query: { code: code }})
    },
    courseStatus(courseId,planId){
      this.id = courseId;
      this.planId = planId;
      this.auditStatus();
    },
    auditStatus(){
      let token =  localStorage.getItem('token')
      if(!token){
        this.$message({
          message: '请先登录！',
          type: 'warning',
          offset:100
        })
        setTimeout(() => {
          this.$router.push({path:'/login/login'})
        }, 2000);
      }else{
        this.getUserInfo();
      }
    },
    // 获取个人信息
    getUserInfo(){
      userInfo().then(res => {
        this.userInfo = res.data;
        let statusl = res.data.auditStatus;
        if(statusl==1){
          this.dialogFormVisible1 = true
        }else{
          this.$message({
            message: '请进行实名认证后再次操作！',
            type: 'warning',
            offset:100
          })
          setTimeout(() => {
            this.$router.push({path:'/personal/personal'})
          }, 2000);
        }
      })
    },

    // 获取课程详情
    getCourseInfo(){
      let params = {
        id:this.id,
        discount:this.discount
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      courseInfo(params).then(res => {
        this.info = res.data;
        if(res.data.plans.length>0){
          this.getPlanInfo(res.data.plans[0].id,0)
        }else{
          this.groupList = res.data.groupList;
          this.lectures = res.data.lectures;
        }
        if(this.info.courseMember){
          this.learnProcess = res.data.courseMember.learnProcess * 100
        }
        if(this.discount){
          let coursePrice = res.data.coursePrice * res.data.discount;
					this.info.coursePrice = coursePrice.toFixed(2)
        }
        let couponsList = [];
        res.data.couponsList.forEach((item,i) => {
          if(item.isShow==1){
            couponsList.push(item)
          }
				})
        this.couponsList = couponsList;

        this.info.couponsList.forEach((item,i) => {
					item.checked = false;
				})

        if(res.data.courseMaterial){
          let courseMaterial = JSON.parse(res.data.courseMaterial);
          this.info.courseMaterial = courseMaterial;
        }

        // loading.close();
      })
      // .catch(err => {
      //   loading.close();
      // })
    },

    // 开课计划详情
    getPlanInfo(id,i){
      let params = {
        id:id
      }
      planInfo(params).then(res => {
        this.planIndex = i;
        this.groupList = res.data.groupList;
        this.lectures = res.data.lectures;
        this.planDetail = res.data.planDetail
      })
    },

    onCoupon(id,discountRatio){
      this.info.couponsList.forEach((item,i) =>{
        if(item.id == id){
          item.checked = !item.checked
          if(item.checked){
            this.couponChecked = true;
            this.couponId = id;
            this.discountRatio = discountRatio;
          }else{
            this.couponChecked = false;
            this.discountRatio = -1;
          }
        }else{
          item.checked = false;
        }
      })
      console.log(id,this.couponChecked)
      this.$forceUpdate()

    },

    // 领取优惠券
    getCoupon(id){
      let params = {
        couponId:id
      }
      const loading = this.$loading({
        lock: true,
        text: '领取中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      getCoupon(params).then(res => {
        if(res.code==0){
          this.$message({
            message: '领取成功！',
            type: 'success',
            offset:100
          })
          this.getCourseInfo()
        }else{
          this.$message({
            message: res.msg,
            type: 'success',
            offset:100
          })
        }
        loading.close();
      })
      .catch(err => {
        loading.close();
      })
    },

    signUp(){
      if(!this.checked){
        this.$message({
          message: '请阅读并勾选《海量数据学院考试规则及隐私政策》',
          type: 'warning',
          offset:100
        })
        return
      }
      this.submitForm();
      
    },
    submitForm() {
      let params = {
        courseId:this.id,
        discount:this.discount,
        planId:this.planId
      }
      courseSign(params).then(res => {
        if(res.code==0){
          this.dialogFormVisible1 = false;
          this.payInfo = res.data;
          this.orderId = res.data.id;
          this.dialogFormVisible2 = true;
        }
      })
    },

    onNextStep(){
      if(this.couponChecked || this.discount){
        this.editExamOrder()
      }else{
        this.submitCoupon()
      }
    },
    editExamOrder(){
      let params = {
        couponId:this.couponChecked?this.couponId:'',
        orderId:this.orderId,
        discountId:this.discount
      }
      console.log("params",params)
      // return
      editExamOrder(params).then(res => {
        if(res.code==0){
          let salePrice = this.info.coursePrice
          if(this.couponChecked){
            salePrice = this.info.coursePrice*this.discountRatio
          }
          if(salePrice>0){
            this.submitCoupon()
          }else{
            this.$message({
              message: '支付成功',
              type: 'success',
              offset:100
            })
            setTimeout(() => {
              this.$router.push({path:'/course/course'})
            }, 1500)
          }
        }
      })
    },
    
     // 跳转支付
    submitCoupon(){
      let payType = this.payCur==0?3:6;
      if(payType==6){
        // 'de9e80378ebf4f6fbad0fedde1140626'
        // this.$router.push({path:'/pay/Orderz', query: { payType: 6,orderId:this.orderId}})
        window.open('#/pay/Orderz?payType=6&orderId='+this.orderId, '_blank');
        this.dialogFormVisible2 = false;
      }else{
        this.dialogFormVisible6 = true;
        let params = {
          payType:3,
          orderId:this.orderId,
        }
        coursePay(params).then(res => {
          console.log('支付',res);
          if(res.code==0){
            this.examHtml = res.data;
          }
        })
        .catch(err => {
        })
      }
    },

    getOrderInfo(){
      orderInfo({id:this.orderId}).then(res => {
        console.log('支付详情',res);
        let orderStatus = res.data.status;
        if(orderStatus==0){
          this.$message({
            message: '您还未支付',
            type: 'warning',
            offset:100
          })
        }else{
          location.reload()
        }
      })
    },

    // 下载文件
    downloadFile(fileName) {
      // let url = JSON.parse(fileName)
      const loading = this.$loading({
        lock: true,
        text: '下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // window.location.href = fileName
      console.log(fileName)
      window.location.href = fileName;
      loading.close();
    },

    // 收藏
    onCollect(){
      collectCourse({courseId:this.id}).then(res => {
        console.log('收藏',res.data);
        if(res.code == 0){
          this.info.ifCollection = res.data
        }
      })
    },

    onInstructor(e){
      this.isInstructor = !this.isInstructor
    },

    onChecked(e){
      this.payCur = e;
    },

    playback(id,learnDuration,pullUrl,liveStatus){

      if(localStorage.getItem('token')){
        if(this.info.type==2){
          let ifSign = this.info.plans[this.planIndex].ifSign;
          if(ifSign==1){
            this.$router.push({path:'/index/tcplayer', query: {id:this.id, url: pullUrl,status:liveStatus}})
          }else{
            this.$message({
              message: '请购买课程后在进行观看',
              type: 'warning',
              offset:100
            })
          }
        }else{
          if(this.info.ifSign==1){
            this.$router.push({path:'/index/playback', query: { tid:this.id, id: id,ifSign:this.info.ifSign,learnDuration:learnDuration }})
          }else{
            if(learnDuration){
              this.$router.push({path:'/index/playback', query: { tid:this.id, id: id,ifSign:this.info.ifSign,learnDuration:learnDuration }})
            }else{
              this.$message({
                message: '不支持试看',
                type: 'warning',
                offset:100
              })
            }
          }
        }
      }else{
        this.$message({
          message: '请先登录',
          type: 'warning',
          offset:100
        })
        setTimeout(() => {
          window.location.href = '/pc'
        }, 1500);
      }
    },
    copyText() {
      const input = document.createElement('input');
      input.value = 'https://education.vastdata.com.cn/mobile/#/pages/course/details?id='+this.id+'&type=1'; // 获取要复制的文本
      document.body.appendChild(input);
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行复制操作
      document.body.removeChild(input); // 移除临时的输入框
      this.$message({
        message: '链接已复制',
        type: 'success',
        offset:100
      })
    }
    
  }
}
</script>
<style scoped>

  .authentication{
    margin-top: 30px;
    background: #fff;
    padding: 20px;
    border-radius: 6px;
  }
  .product-image{
    width: 42%;
    /* height: 250px; */
    margin-right: 30px;
    border-radius: 4px;
  }
  .product-card{
    
    flex: 1;
  }
  .product-card-name{
    font-size: 18px;
    color:black;
    padding-bottom: 14px;
    border-bottom: 1px solid #EFEFEF;
  }
  .product-card-kv{
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 10px;
    background: #fffbf8;
  }
  .product-card-kv .key{
    font-size: 13px;
    padding: 6px 0;
    background: url('../../assets/img/icon1.png') left center/10px 10px no-repeat;
    padding-left: 14px;
    color: #8f8f8f;
  }
  .product-card-kv .key span{
    font-size: 13px;
    color: black;
  }
  
  .product-card-enroll{
    display: flex;
    align-items: center;
  }
  .product-card-enroll-moeny{
    font-size: 26px;
    color: #f25801;
    margin-right: 20px;
  }
  .product-card-enroll-moeny span{
    font-size: 14px;
  }
  .product-card-enroll-originalPrice{
    text-decoration: line-through;
    font-size: 13px;
    color: #a0a0a0;
    margin-right: 40px;
  }
  .product-card-enroll-share{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #e6e6e6;
    cursor: pointer;
  }
  .product-card-enroll-share img{
    width: 12px;
    height: 12px;
    margin: 0 10px 0 16px;
  }
  .product-card-enroll-share p{
    font-size: 12px;
    color: #babbbe;
  }

  .exam-contetn{
    display: flex;
    padding-bottom: 50px;
  }
  .exam-contetn-text{
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    margin-right: 30px;
  }
  .course{
    margin-bottom: 30px
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
    width: 100%;
    margin-bottom: 30px;
  }
 
  .title{
    font-size: 16px;
    font-weight: 600;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 6px;
  }
  .tiao{
    height: 3px;
    background: #fe6a00;
    border-radius: 4px;
  }
  .exam-contetn-item{
    /* background: #fff; */
    
    flex: 1;
  }
  .instructor{
    background: #fff;
    padding: 30px 16px 12px;
    border-radius: 8px;
    margin-bottom: 20px;
  }
  .correlation-title,.instructor-title{
    font-size: 16px;
    color: black;
    border-left: 3px solid #f25801;
    padding-left: 10px;
    line-height: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .instructor ul{
    border-top: 1px solid #f1f1f1;
    margin-bottom: 15px;
    padding: 10px 0 0;
  }
  .instructor li{
    padding: 15px 0;
    display: flex;
    align-items: flex-start;
  }
  .instructor-avatar{
    width: 60px;
    height: 60px;
    margin-right: 12px;
    border-radius: 50%;
  }
  .instructor-item{
    flex: 1;
  }
  .instructor-item-name{
    font-family: SourceHanSansCN;
    font-weight: 600;
    font-size: 16px;
    color: #151515;
    line-height: 14px;
    margin-bottom: 10px;
  }
  .instructor-item-speciality{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #666666;
    line-height: 23px;
    /* overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; */
  }

  .correlation{
    background: #fff;
    padding: 30px 16px 20px;
    border-radius: 8px;
  }
  .correlation ul li{
    border-top: 1px solid #f1f1f1;
    margin-bottom: 15px;
    padding: 14px 0 4px;
    cursor: pointer;
  }
  .correlation-item-img{
    width: 100%;
    border-radius: 8px;
    margin-bottom: 10px;
  }
  .correlation-item-name{
    font-size: 14px;
    color: black;
    margin-bottom: 8px;
  }
  .correlation-item-time{
    display: flex;
    align-items: center;
  }
  .correlation-item-time-img{
    width: 12px !important;
    margin-right: 6px;
    border-radius: 0 !important;
    margin-bottom: 0 !important;
    margin-right: 8px;
  }
  .correlation-item-time span{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
  }

  .popup /deep/ .el-dialog__header, .popup /deep/ .el-dialog__body{
    padding: 0;
  }
  .popup /deep/  .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 19px;
  }
  .popup /deep/  .el-dialog{
    border-radius: 8px;
  }
  .popup-title{
    background: #ff821e;
    color: #fff;
    font-size: 16px;
    padding: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .popup-form{
    padding: 40px 110px;
  }
  .el-button--small{
    padding: 10px 80px;
  }
  .el-checkbox__label{
  font-size: 10px;
}
.checked{
  margin-bottom: 30px;
}
.checked span{
  font-size: 10px;
  color: #adadad;
}
.checked .checkbox-span{
  color: #adadad;
  cursor: pointer;
}
.checked /deep/ .el-checkbox__label{
  color: #999 !important;
  font-size: 10px;
  padding-left: 6px;
}
.el-checkbox__input.is-checked+.el-checkbox__label{
  color: #adadad;
}
.checked /deep/ .is-checked .el-checkbox__inner{
  background-color: #adadad;
}
.checked /deep/ .el-checkbox__inner{
  width: 12px;
  height: 12px;
  border: 1px solid #adadad;
  margin-top: 2px;
}
.el-checkbox__input.is-checked .el-checkbox__inner{
  background-color: #adadad;
  color: #adadad;
  border: 1px solid #adadad;
}
.el-checkbox__input.is-focusel-checkbox_immer{
  border: 1px solid #adadad;
}
.popup-form-title{
  font-size: 14px;
  color: black;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.popup-form-title span{
  font-size: 15px;
  color: #f25902;
  margin-right: 2px;
}
.popup-form-moeny{
  font-size: 28px;
  color: #f25902;
  margin-bottom: 12px;
}
.popup-form-moeny span{
  font-size: 15px;
  color: #f25902;
}
.el-collapse-item__header{
  padding-left:10px;
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
}
.el-collapse-item__header.is-active,.el-collapse-item__header, .el-collapse-item__wrap{
  color: #a9a9a9;
  border-bottom: 1px solid #EBEEF5;
}
.el-button--medium{
  width: 48%;
  padding: 14px 20px;
}
.popup-form-tips{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f4f7;
  border-radius: 8px;
  padding: 22px 20px;
  margin-bottom: 60px;
}
.popup-form-tips-text,.popup-form-tips-type{
  font-size: 14px;
  color: #727373;
}
.popup-form-tips-sub{
  font-size: 14px;
  color: #f25902;
  cursor: pointer;
}
.popup-form-tips-g{
  width: 1px;
  height: 30px;
  background: #dfe3e6;
}

.popup-coupon{
  flex-wrap: wrap;
  justify-content: space-between;
}
.popup-coupon-item{
  width: 48%;
  margin:0 0 30px;
}
.popup-coupon-cur{
  border: 1px solid #eeeeee;
}
.product-card-coupon{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
.product-card-coupon-item{
    width: 44%;
    height: 50px;
    border: 1px solid #ffe2ca;
    display: flex;
    align-items: center;
    margin-right: 8px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
.product-card-coupon-item-discount{
    width: 54px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(bottom,#ff6f19,#ff8c15);
    font-size: 22px;
    color: #fff;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    margin-right: 10px;
}
.product-card-coupon-item-discount span{
  font-size: 12px;
}
.product-card-coupon-item-content-name{
    font-size: 12px;
    color: #f26212;
    margin-bottom: 8px;
    line-height: 12px;
}
.product-card-coupon-item-content-time{
    font-size: 10px;
    color: #a1a1a1;
    line-height: 10px;
}
.product-card-coupon-item-receive{
    width: 20px;
    height: 100%;
    border-left: 1px dotted #ffe4cd;
    font-size: 14px;
    color: #f26212;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background: #fff3eb;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    cursor: pointer;
  }
.popup-form-coupon .product-card-coupon-item-receive{
  background: none;
  border-left: none;
}
.popup-form-coupon .product-card-coupon-item-receive img{
  width: 20px;
  height: 20px;
}
.product-card-coupon-item-content{
  width: 63%;
}

.popup-share-img{
  width: 200px;
  height: 200px;
  margin-bottom: 26px;
}
.popup-share-text{
  font-size: 15px;
  color: black;
  text-align: center;
  border-bottom: 2px dotted  #ebebeb;
  padding-bottom: 20px;
  margin-bottom: 30px;
}
.popup-share-copy{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  cursor: pointer;
}
.popup-share-copy p{
  font-size: 12px;
  color: #999999;
  margin-right: 4px;
}
.popup-share-copy img{
  width: 16px;
  height: 16px
}
.buttons{
    color: #f35903;
    border:1px solid #f35903;
    background: #FEFBF8;;
  }
  .buttons:hover{
    background: none;
  }
  .plan{
    margin-top: 20px;
  }
  .plan-ul{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }
  .plan-ul-li{
    border-radius: 6px;
    border: 1px solid #E6E6E6;
    padding: 12px 16px;
    width: 45.8%;
    margin-bottom: 14px;
  }
  .plan-ul-li-qi{
    display: flex;
    align-items: center;
  }
  .plan-ul-li-qi-p1{
    font-size: 15px;
    padding: 6px 0;
    background: url('../../assets/img/icon1.png') left center/10px 10px no-repeat;
    padding-left: 18px;
    color: #151515;
    margin-right: 10px;
  }
  .plan-ul-li-qi-p2{
    padding: 2px 8px;
    background: rgba(239,127,30,0.1);
    border-radius: 2px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #F25902;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .plan-ul-li-date{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .plan-ul-li-date p{
    display: flex;
    align-items: center;
    padding-left: 18px;
  }
  .plan-ul-li-date p img{
    width: 12px;
    margin-right: 6px;
  }
  .plan-ul-li-date p span{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #999999;
  }
  .textbook{
    height: 40px;
    background: #FEFBF8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 4px;
    padding: 0 14px;
  }
  .textbook p{
    display: flex;
    align-items: center;
  }
  .textbook p img{
    width: 13px;
    margin-right: 6px;
  }
  .textbook p span{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #151515;
    line-height: 13px;
  }

  .problem{
    margin-top: 30px;
  }
  .el-collapse{
    border: none;
  }
  .el-collapse-item{
    margin-bottom: 20px;
    border-radius: 8px;
  }
  .problem /deep/ .el-collapse-item__header{
    background:#FEFBF8;
  }
  .problem /deep/ .el-collapse-item__header, .problem /deep/ .el-collapse-item__wrap{
    border: none;
    padding-left: 16px;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }

  .titles{
    font-size: 15px;
    color: #333;
    font-weight: 600;
  }
  .problem .text{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:16px 0 16px 0;
    border-bottom: 1px dashed #E5E5E5;
    cursor: pointer;
  }
  .text-name{
    display: flex;
    align-items: center;
  }
  .text-name img{
    width: 20px;
    margin-right: 10px;
  }
  .text-name span{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    line-height: 13px;
  }
  .text-time{
    display: flex;
    align-items: center;
  }
  .text-time span{
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 12px;
    margin-right: 30px;
  }
  .text-time p{
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
    color: #FF4800;
    line-height: 12px;
    padding: 4px 12px;
    background: #FFECE5;
    border-radius: 20px;
    cursor: pointer;
  }
  .progress /deep/ .el-progress-bar{
    padding-right: 0;
    margin: 16px 0;
  }
  .progress /deep/ .el-progress__text{
    display: none
  }
  .progress{
    border-top: 1px solid #f1f1f1;
    margin-bottom: 15px;
    padding: 16px 0 0;
  }
  .progress p{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 12px;
  }
  .text-time-record{
    width: 110px;
    height: 18.5px;
    background: rgba(230,230,230,0);
    border-radius: 14px;
    border: 1px solid #F25902;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #FF4800;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin:0 20px 0 70px;
  }
  .popup-table{
    border: 1px solid #E6E6E6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0 50px;
  }
  .popup-table-column-key{
    height: 40px;
    background: #FFF1E5;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    line-height: 40px;
    padding-left: 20px;
  }
  .popup-table-column-val{
    height: 40px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 40px;
    padding-left: 20px;
  }
  .popup-way{
    margin-bottom: 20px;
  }
  .popup-way-title{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 14px;
    margin-bottom: 15px;
  }
  .popup-way ul{
    display: flex;
    align-items:center;
    justify-content: space-between;
  }
  .popup-way-item{
    display: flex;
    align-items:center;
    justify-content: center;
    border: 1px solid #E6E6E6;
    width: 48%;
    height: 70px;
    cursor: pointer;
  }
  .popup-way-item-checked{
    width: 12px;
  }
  .popup-way-item-wx{
    width: 22px;
    margin: 0 12px;
  }
  .popup-way-item-name{
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 14px;
  }

  .popup-pay{
    background: #FAFAFA;
    padding: 27px;
  }
  .popup-pay-type{
    display: flex;
    align-items: center;
  }
  .popup-pay-item{
    background: #fff;
    padding: 10px;
    border: 1px solid #E1E1E1;
    border-radius: 4px;
  }
  .popup-pay-item-code{
    width: 90px;
    margin-bottom: 10px;
  }
  .popup-pay-item-val{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .popup-pay-item-val img{
    width: 16px;
    margin-right: 10px;
  }
  .popup-pay-item-val p{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 12px;
  }
  .popup-pay-moeny{
    margin-left: 24px;
  }
  .popup-pay-moeny-key{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #999999;
    line-height: 13px;
    margin-bottom: 12px;
  }
  .popup-pay-moeny-tips{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 12px;
  }
  .popup-pay-moeny-tips span{
    color: #F25902;
  }
  .popup-pay-transfer ul li{
    display: flex;
    align-items: center;
  }
  .popup-pay-transfer ul li .key{
    width: 150px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #999999;
    line-height: 49px;
  }
  .popup-pay-transfer ul li .val{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #999999;
    line-height: 49px;
  }
  .popup-pay-zhu{
    height: 40px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #F25902;
    line-height: 40px;
    padding: 0 10px;
    background: #FBECE1;
    border-radius: 4px;
    margin-top: 10px;
  }
  .popup-form-coupon{
  margin-bottom: 20px;
}
.el-collapse-item__header{
  padding-left:10px;
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
}
.el-collapse-item__header.is-active,.el-collapse-item__header, .el-collapse-item__wrap{
  color: #a9a9a9;
  border-bottom: 1px solid #EBEEF5;
}
.popup-form-coupon .product-card-coupon{
  padding: 14px 2px 10px;
  box-shadow: 0 0 10px rgba(222, 207, 207, 0.5);
  margin: 10px 0;
}
.product-card-coupon-more{
  width: 56px;
  height: 50px;
  background: #f5f5f5;
  color: #b9b9b9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
}
.marker /deep/ ol{
  width: auto !important;
}
.marker /deep/ ul{
  display: block;
  list-style-type: decimal;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
  unicode-bidi: isolate;
}
.marker /deep/ li{
  list-style:auto;
}
.marker /deep/ img{
  max-width: 100%;
}
.marker /deep/ table{
  max-width: 100%;
}
.marker /deep/ p{
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/index/classroomDetails.vue